var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAiMagicWand = function SvgAiMagicWand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13.999,
    viewBox: "0 0 14 13.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "auto_fix_FILL0_wght400_GRAD0_opsz48",
    d: "M92.114-917.371l-.566-1.248-1.248-.566,1.248-.566L92.114-921l.566,1.249,1.248.566-1.248.566Zm-8.023,0-.566-1.248-1.248-.566,1.248-.566L84.091-921l.566,1.249,1.248.566-1.248.566Zm8.023,8.023-.566-1.248-1.248-.566,1.248-.566.566-1.248.566,1.248,1.248.566-1.248.566Zm-10.4,2.147-1.581-1.581a.649.649,0,0,1-.2-.425.583.583,0,0,1,.2-.458l7.49-7.49a.658.658,0,0,1,.483-.2.658.658,0,0,1,.483.2l1.5,1.5a.658.658,0,0,1,.2.483.658.658,0,0,1-.2.483l-7.49,7.49a.612.612,0,0,1-.441.2A.612.612,0,0,1,81.711-907.2Zm.383-.949,5.21-5.21-1.032-1.032-5.21,5.21Z",
    transform: "translate(-79.928 921)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiMagicWand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AiMagicWand.aae83e17.svg";
export { ForwardRef as ReactComponent };